var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"file-select"},[_c('div',{staticClass:"select-button"},[(_vm.value)?_c('span',[_vm._v("Selected File: "+_vm._s(_vm.value.name))]):_c('span',[_vm._v("Select Logo Image")])]),_c('input',{attrs:{"type":"file"},on:{"change":_vm.handleFileChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }